import React, { useMemo } from 'react';
import Text, { TextSize } from '@move-ui/text';
import cx from 'classnames';
import styles from './MileageRatingScale.module.css';
export var MileageRating;
(function (MileageRating) {
    MileageRating["Low"] = "low";
    MileageRating["Average"] = "average";
    MileageRating["High"] = "high";
})(MileageRating || (MileageRating = {}));
const MileageRatingScale = ({ usage, downBarLowMessage, upperBarLowMessage, upperBarAverageMessage, upperBarHighMessage, downBarAverageMessage, downBarHighMessage, className }) => {
    const ratingData = useMemo(() => [
        {
            id: MileageRating.Low,
            dataTestId: 'mileageLow',
            upperMessage: upperBarLowMessage,
            downMessage: downBarLowMessage,
            barClassName: styles.lineLow
        },
        {
            id: MileageRating.Average,
            dataTestId: 'mileageAverage',
            upperMessage: upperBarAverageMessage,
            downMessage: downBarAverageMessage,
            barClassName: styles.lineHigh
        },
        {
            id: MileageRating.High,
            dataTestId: 'mileageHigh',
            upperMessage: upperBarHighMessage,
            downMessage: downBarHighMessage,
            barClassName: styles.lineAverage
        }
    ], [
        downBarLowMessage,
        downBarAverageMessage,
        downBarHighMessage,
        upperBarAverageMessage,
        upperBarHighMessage,
        upperBarLowMessage
    ]);
    return (React.createElement("ul", { className: cx(styles.bar, className), "data-testid": "MileageRatingScale" }, ratingData.map(({ id, dataTestId, upperMessage, downMessage, barClassName }) => {
        const isActive = usage === id;
        return (React.createElement("li", { key: id, className: cx(styles.barSegment, {
                [styles.active]: isActive
            }), "data-testid": dataTestId },
            React.createElement("div", null,
                React.createElement(Text, { color: "neutral-200", size: TextSize.XXS }, upperMessage)),
            React.createElement("div", null,
                React.createElement("div", { className: cx(styles.line, barClassName) })),
            React.createElement("div", null,
                React.createElement(Text, { className: styles.barSegmentLabel, color: "neutral-200", size: TextSize.XS }, downMessage))));
    })));
};
export default MileageRatingScale;
//# sourceMappingURL=MileageRatingScale.js.map